import React, { useState } from 'react';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip as ChartTooltip,
  Legend,
} from 'chart.js';
import { Pie } from 'react-chartjs-2';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import FAQSchema from '../../FAQSchema';
import { motion } from 'framer-motion';
import AdBanner from '../AdPage/AdBanner';
// Register necessary components
ChartJS.register(
  ArcElement,
  ChartTooltip,
  Legend
);

const EducationLoanEmiCalculator = () => {
  const [loanAmount, setLoanAmount] = useState(500000);
  const [interestRate, setInterestRate] = useState(8);
  const [loanTenure, setLoanTenure] = useState(5);
  const [monthlyEMI, setMonthlyEMI] = useState(0);
  const [totalInterest, setTotalInterest] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [amortizationSchedule, setAmortizationSchedule] = useState([]);
  const [activeYear, setActiveYear] = useState(null);

  const calculateEMI = () => {
    const principal = loanAmount;
    const annualInterest = interestRate / 100;
    const monthlyInterest = annualInterest / 12;
    const tenureInMonths = loanTenure * 12;

    const emi =
      (principal * monthlyInterest * Math.pow(1 + monthlyInterest, tenureInMonths)) /
      (Math.pow(1 + monthlyInterest, tenureInMonths) - 1);

    const totalAmount = emi * tenureInMonths;
    const totalInterest = totalAmount - principal;

    setMonthlyEMI(emi.toFixed(2));
    setTotalInterest(totalInterest.toFixed(2));
    setTotalAmount(totalAmount.toFixed(2));

    const schedule = [];
    let balance = principal;
    // let currentYear = new Date().getFullYear();
    let currentYear = new Date().getFullYear();

    let currentMonth = 6;

    for (let i = 0; i < tenureInMonths; i++) {
      const interestForMonth = balance * monthlyInterest;
      const principalForMonth = emi - interestForMonth;
      balance -= principalForMonth;

      schedule.push({
        // month: i + 1,
        // year: year,
        month: (currentMonth + i) % 12 + 1, // Ensure month is in range 1-12
        year: currentYear + Math.floor((currentMonth + i) / 12),
        principalPaid: principalForMonth,
        interestPaid: interestForMonth,
        totalPayment: emi,
        balance: balance,
      });

      // if ((i + 1) % 12 === 0) {
      //   year++;
      // }
    }

    setAmortizationSchedule(schedule);
  };

  const handleLoanAmountChange = (e) => {
    const value = e.target.value;
    setLoanAmount(value === '' ? 0 : parseInt(value));
  };

  const handleInterestRateChange = (e) => {
    const value = e.target.value;
    setInterestRate(value === '' ? 0 : parseFloat(value));
  };

  const handleLoanTenureChange = (e) => {
    const value = e.target.value;
    setLoanTenure(value === '' ? 0 : parseInt(value));
  };

  const handleYearToggle = (year) => {
    setActiveYear(activeYear === year ? null : year);
  };

  const data = {
    labels: ['Principal Amount', 'Total Interest'],
    datasets: [
      {
        label: 'EMI Breakdown',
        data: [loanAmount, totalInterest],
        backgroundColor: ['#36A2EB', '#FF6384'],
      },
    ],
  };
function Icon({ id, open }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
        </svg>
    );
  }
  
  
    const [activeIndex, setActiveIndex] = useState(0);
  
     
    const faqs = [
        {
            question: "What is the ideal loan tenure for education loans?",
            answer: "Loan tenures typically range from 5 to 15 years. Longer tenures reduce EMIs but increase total interest paid."
          },
          {
            question: "Can I change my loan tenure later?",
            answer: "Some banks allow restructuring of loans, including tenure changes, based on your repayment history."
          },
          {
            question: "Does EMI start during the course?",
            answer: "Usually, repayment starts after the moratorium, but some banks may charge simple interest during the course."
          },
          {
            question: "How do I calculate EMIs during the moratorium period?",
            answer: "EMIs are not applicable during this period, but interest may accumulate. The calculator considers this when configured."
          },
          {
            question: "Can I make part payments during my moratorium?",
            answer: "Yes, and doing so can reduce your loan burden significantly."
          },
          {
            question: "Does this calculator work for studying abroad?",
            answer: "Absolutely. You can enter the loan amount and interest rate based on your lender’s international education loan policy."
          },
          {
            question: "What details do I need to use the calculator?",
            answer: "You need the loan amount, interest rate, and repayment tenure. Optional: moratorium period."
          },
          {
            question: "How accurate is the calculator?",
            answer: "It gives a very close estimate. Actual EMI may vary slightly based on lender-specific terms."
          },
          {
            question: "Does using this calculator impact my credit score?",
            answer: "No. It is a free-to-use tool and does not require any personal credit information."
          },
          {
            question: "Can co-borrowers use this tool?",
            answer: "Yes, the tool helps both students and co-borrowers plan for repayments."
          },
          {
            question: "Is there any limit to how many times I can use it?",
            answer: "No, you can use it any number of times to simulate different scenarios."
          },
          {
            question: "Does the calculator include processing fees or other charges?",
            answer: "No, it only considers principal, interest rate, and tenure."
          },
          {
            question: "Can I use it for a top-up education loan?",
            answer: "Yes, enter the revised total amount including the top-up."
          },
          {
            question: "Is there a mobile version of this calculator?",
            answer: "Yes, TheFinMaster’s calculator is fully mobile-optimized."
          },
          {
            question: "How do I use this to compare different lenders?",
            answer: "Change the interest rate and tenure values as per each lender’s offer to compare their EMIs side-by-side."
          }
        ]
    const toggleAccordion = (index) => {
      if (activeIndex === index) {
          // If the clicked question is already expanded, collapse it
          setActiveIndex(null);
      } else {
          // If the clicked question is not expanded, expand it
          setActiveIndex(index);
      };
    }
    const calculators = [
      {
        name: 'SBI Education Loan Calculator',
        path: '/financial-tools-calculators/sbi-education-loan-emi-calculator',
        image: '/assets/sb.png',
      },
      {
        name: 'HDFC Education Loan Calculator',
        path: '/financial-tools-calculators/hdfc-education-loan-emi-calculator',
        image: '/assets/hd.png',
      },
      {
        name: 'ICICI Education Loan Calculator',
        path: '/financial-tools-calculators/icici-education-loan-emi-calculator',
        image: '/assets/icc.png',
      },
      {
        name: 'Axis Education Loan Calculator',
        path: '/financial-tools-calculators/axis-education-loan-emi-calculator',
        image: '/assets/ax.png',
      },
      {
        name: 'PNB Education Loan Calculator',
        path: '/financial-tools-calculators/pnb-education-loan-emi-calculator',
        image: '/assets/pn.png',
      },
      {
        name: 'BOB Education Loan Calculator',
        path: '/financial-tools-calculators/bank-of-baroda-education-loan-emi-calculator',
        image: '/assets/bb.png',
      },
      {
        name: 'Kotak Education Loan Calculator',
        path: '/financial-tools-calculators/kotak-education-loan-emi-calculator',
        image: '/assets/kot.png',
      },
      {
        name: 'Canara Education Loan Calculator',
        path: '/financial-tools-calculators/canara-education-loan-emi-calculator',
        image: '/assets/can.png',
      },
      {
        name: 'IDFC Education Loan Calculator',
        path: '/financial-tools-calculators/idfc-education-loan-emi-calculator',
        image: '/assets/idd1.png',
      },
      {
        name: 'Federal Education Loan Calculator',
        path: '/financial-tools-calculators/federal-education-loan-emi-calculator',
        image: '/assets/fdd.png',
      },
      // {
      //   name: 'Central Bank of India Gold  Loan Calculator',
      //   path: '/financial-tools-calculators/central-bank-of-india-gold-loan-emi-calculator',
      //   image: '/assets/ax.png',
      // },
      // {
      //   name: 'Indian Bank Gold  Loan Calculator',
      //   path: '/financial-tools-calculators/indian-bank-gold-loan-emi-calculator',
      //   image: '/assets/ax.png',
      // },
   
     
   
     
     
    ];
  return (
    <>
     <Helmet>
         <title>Education Loan EMI Calculator – Plan Student Loan Repayment</title>
        <meta  name='description' content='Calculate your education loan EMI, interest, and tenure using our student loan EMI calculator.'/>
        <link rel="canonical" href="https://thefinmaster.com/financial-tools-calculators/education-loan-emi-calculator" />
        <meta name="robots" content="max-snippet:-1, max-image-preview:standard" />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <FAQSchema faqs={faqs} />
      {/* <nav className="text-gray-500 text-sm my-4 ml-10" aria-label="Breadcrumb">
      <ol className="list-none p-0 inline-flex">
        <li className="flex items-center">
          <Link to="/" className="text-blue-600 hover:text-blue-800 ">Home</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li>
        <li className="flex items-center">
          <Link to="/financial-tools-calculators" className="text-blue-600 hover:text-blue-800">Financial Tools Calculators</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li>
          <li className="flex items-center">
          <span className="text-gray-500 ">Business Loan EMI Calculator</span>
        </li> 
      
      </ol>
    </nav> */}
      <div className="w-full flex justify-center items-center px-4 mt-20">
  <div className="w-full max-w-5xl h-auto object-contain rounded-lg shadow-md transition duration-300 hover:scale-105">
  <AdBanner displayOrder="1" />
  </div>
</div>
        <div className='py-4'>
    <div className="container mx-auto p-4 shadow-xl rounded-md">
            <h1 className="text-2xl font-bold mb-4">Education Loan EMI Calculator</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Loan Amount</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                value={loanAmount}
                onChange={handleLoanAmountChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">₹ {loanAmount.toLocaleString()}</span>
            </div>
            <input
              type="range"
              min="0"
              max="10000000"
              value={loanAmount}
              onChange={(e) => setLoanAmount(parseInt(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Rate of Interest (P.A.)</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                max="100"
                step="0.1"
                value={interestRate}
                onChange={handleInterestRateChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">{interestRate} %</span>
            </div>
            <input
              type="range"
              min="0"
              max="15"
              step="0.1"
              value={interestRate}
              onChange={(e) => setInterestRate(parseFloat(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Loan Tenure (Years)</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                max="30"
                value={loanTenure}
                onChange={handleLoanTenureChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">{loanTenure} Yr</span>
            </div>
            <input
              type="range"
              min="0"
              max="30"
              value={loanTenure}
              onChange={(e) => setLoanTenure(parseInt(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <button
            onClick={calculateEMI}
            className="bg-blue-500 text-white px-4 py-2 rounded"
          >
            Calculate
          </button>
        </div>
        <div>
          <div className="mb-4">
            <h2 className="text-xl font-bold">Results</h2>
            <p>Monthly EMI: ₹ {parseFloat(monthlyEMI).toLocaleString()}</p>
            <p>Total Principal Amount: ₹ {loanAmount.toLocaleString()}</p>
            <p>Total Interest: ₹ {parseFloat(totalInterest).toLocaleString()}</p>
            <p>Total Amount (Principal + Interest): ₹ {parseFloat(totalAmount).toLocaleString()}</p>
          </div>
          <div>
            <h2 className="text-xl font-bold">Breakdown</h2>
            <div className="flex justify-center">
              <Pie data={data} options={{ maintainAspectRatio: false }} width={300} height={300} />
            </div>
          </div>
        </div>
      </div>
      <div className="mt-6">
        <h2 className="text-xl font-bold mb-4">Amortization Schedule</h2>
        {amortizationSchedule.length > 0 && (
          <div className="flex flex-col space-y-4">
            {Array.from(new Set(amortizationSchedule.map(item => item.year))).map((year, idx) => (
              <div key={idx} className="mb-4 border rounded-md shadow-md">
                <div
                  className={`cursor-pointer text-lg font-semibold bg-gray-100 p-4 flex justify-between items-center ${activeYear === year ? 'bg-blue-100' : ''}`}
                  onClick={() => handleYearToggle(year)}
                >
                  <span>{year}</span>
                  <span>{activeYear === year ? '-' : '+'}</span>
                </div>
                {activeYear === year && (
                  <div className="overflow-x-auto">
                    <table className="min-w-full bg-white rounded-md shadow-md">
                      <thead>
                        <tr>
                          <th className="py-2 px-4 border-b">Month</th>
                          <th className="py-2 px-4 border-b">Principal Paid</th>
                          <th className="py-2 px-4 border-b">Interest Charged</th>
                          <th className="py-2 px-4 border-b">Total Payment</th>
                          <th className="py-2 px-4 border-b">Balance</th>
                        </tr>
                      </thead>
                      <tbody>
                        {amortizationSchedule.filter(item => item.year === year).map((item, idx) => (
                          <tr key={idx}>
                            <td className="py-2 px-4 border-b">{new Date(0, item.month - 1).toLocaleString('default', { month: 'short' })}</td>
                            <td className="py-2 px-4 border-b">₹ {item.principalPaid.toFixed(2).toLocaleString()}</td>
                            <td className="py-2 px-4 border-b">₹ {item.interestPaid.toFixed(2).toLocaleString()}</td>
                            <td className="py-2 px-4 border-b">₹ {item.totalPayment.toFixed(2).toLocaleString()}</td>
                            <td className="py-2 px-4 border-b">₹ {item.balance.toFixed(2).toLocaleString()}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>

     <div className="p-4 sm:p-8 bg-white">
              <h2 className="text-xl sm:text-2xl font-bold mb-6 text-center">
              Education Loan EMI Calculator 
              </h2>
        
                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
                      {calculators.map((calc, index) => (
                        <motion.div
                          key={index}
                          whileHover={{ scale: 1.04 }}
                          initial={{ opacity: 0, y: 20 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{ duration: 0.3, delay: index * 0.05 }}
                        >
                          <Link
                            to={calc.path}
                            className="flex flex-col items-center justify-center text-center border border-gray-200 rounded-lg p-5 bg-white shadow-sm hover:shadow-md transition-all duration-300 h-full min-h-[160px]"
                          >
                            <img
                              src={calc.image}
                              alt={calc.name}
                              className="w-16 h-16 object-contain mb-2"
                            />
                            <span className="text-md font-medium text-gray-800 break-words leading-snug">
                              {calc.name}
                            </span>
                          </Link>
                        </motion.div>
                      ))}
                    </div>
            </div>
     <div className="flex flex-wrap lg:px-6 md:px-6 px-0 py-6" >
     <div className="w-full md:w-2/3 p-4 mx-auto">
     <div className="container mx-auto py-4">
          <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
            Plan Your Education Loan Smartly with TheFinMaster’s EMI Calculator
          </h2>
          <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
            Securing an education loan is an important financial decision, whether you're funding your higher studies or your child’s education. Understanding the impact of EMI (Equated Monthly Installments) on your finances is crucial for managing repayments efficiently. TheFinMaster's Education Loan EMI Calculator helps you plan your loan repayments in advance, giving you a clear idea of how much you’ll need to pay each month, ensuring there are no surprises along the way.
          </p>
          <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
            Using this tool can also help you optimize your loan terms by adjusting the loan amount, tenure, and interest rate. This smart approach allows you to make informed decisions about your education loan, avoid financial strain, and streamline the repayment process. The calculator’s easy-to-use interface helps you get an instant estimate of the monthly EMI amount.
          </p>
          <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
            <strong>Why is it essential?</strong>
          </p>
          <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
            <li><strong>Clarity and Transparency:</strong> You can instantly visualize the monthly repayment amounts, helping you manage your finances better.</li>
            <li><strong>Manage Loan Terms:</strong> Adjust the loan amount and tenure to find the optimal repayment plan.</li>
            <li><strong>Stay on Track:</strong> Plan your education loan repayments in advance and avoid financial hiccups in the future.</li>
          </ul>
</div>
          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is an Education Loan EMI?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              An Education Loan EMI is a fixed monthly amount that a borrower needs to pay towards repaying their loan. The EMI is calculated based on the loan amount, the interest rate, and the repayment tenure.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              When you take an education loan, the lender doesn’t require the repayment to be done in lump sum. Instead, it is divided into manageable monthly installments.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The EMI calculation ensures that the loan is repaid gradually over a set period. The interest component of the EMI will be higher in the initial months and will gradually decrease as the principal balance reduces.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              For example, a loan of ₹5 lakh taken for a tenure of 5 years at an interest rate of 10% annually would have a fixed EMI amount calculated by the formula:
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              EMI = [P x r x (1+r)^n] / [(1+r)^n-1]
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Where:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>P = Loan Amount</li>
              <li>r = Monthly Interest Rate</li>
              <li>n = Loan Tenure in Months</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              This ensures that you can plan your budget around a predictable monthly expense.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Why Use TheFinMaster’s Education Loan EMI Calculator?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Using TheFinMaster’s Education Loan EMI Calculator offers several advantages that can make the entire loan process easier to manage. Here's why it's beneficial:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Instant EMI Calculation:</strong> The calculator provides an instant result, showing the monthly EMI amount you would need to pay, based on your loan amount, interest rate, and tenure.</li>
              <li><strong>Compare Different Loan Terms:</strong> With the ability to adjust the loan amount and tenure, you can see how changes in these factors impact your EMI, helping you choose the most suitable loan structure.</li>
              <li><strong>Budget Planning:</strong> By understanding your monthly repayment amount, you can better plan your finances, avoiding any surprises when the loan repayments begin.</li>
              <li><strong>Understand the Total Cost:</strong> The tool allows you to estimate the total cost of the loan, including both principal and interest, so you can plan how much you will ultimately be paying over the loan term.</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              By using TheFinMaster’s calculator, you can make an informed choice, avoiding financial stress later.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              How Does the Education Loan EMI Calculator Work?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The Education Loan EMI Calculator uses a mathematical formula to determine the fixed monthly payments (EMIs) based on key loan parameters. Let’s break it down step-by-step:
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Formula Explanation:</strong><br />
              The EMI formula used is:<br />
              EMI = [P x r x (1+r)^n] / [(1+r)^n-1]
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Where:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>P = Principal Loan Amount</li>
              <li>r = Monthly Interest Rate (Annual Interest Rate divided by 12)</li>
              <li>n = Total Number of Installments (Loan Tenure in Months)</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Example Calculation:</strong><br />
              Suppose you take an education loan of ₹5,00,000 at an interest rate of 10% per annum for 5 years. Let's calculate the EMI.<br />
              Principal (P) = ₹5,00,000<br />
              Annual Interest Rate = 10%<br />
              Monthly Interest Rate (r) = 10/12 = 0.00833<br />
              Loan Tenure (n) = 5 years = 60 months<br />
              Substituting these values into the formula:<br />
              EMI = [5,00,000 x 0.00833 x (1+0.00833)^60] / [(1+0.00833)^60-1]<br />
              This gives us an EMI of ₹10,624.<br />
              Thus, the EMI for a ₹5,00,000 loan at 10% interest for 5 years would be ₹10,624 per month.
            </p>
          </div>
<div className="w-full flex justify-center items-center my-6 px-4">
          <div className="w-full max-w-[984px]">

     
        <AdBanner displayOrder="3" />
        </div>
         
        </div>
          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Amortization Schedule
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              An amortization schedule is a detailed table that shows each loan payment made during the term of the loan. It breaks down the monthly EMI into two components: principal and interest. At the beginning of the loan, the interest portion is higher, and as you continue making payments, the principal portion increases.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>How Does It Help?</strong>
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Track Progress:</strong> It helps you track how much of your loan principal is paid off each month.</li>
              <li><strong>Interest Breakdown:</strong> See the proportion of your EMI that goes toward interest versus principal, making it easier to understand the loan's financial structure.</li>
              <li><strong>Manage Finances:</strong> It provides transparency on how much interest you will pay over the entire loan term.</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Here's a sample for the first 12 months:
            </p>
            {/* <div className="overflow-x-auto">
              <table className="w-full text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-4 border-collapse">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border px-4 py-2 text-left">Month</th>
                    <th className="border px-4 py-2 text-left">EMI (₹)</th>
                    <th className="border px-4 py-2 text-left">Interest (₹)</th>
                    <th className="border px-4 py-2 text-left">Principal (₹)</th>
                    <th className="border px-4 py-2 text-left">Outstanding (₹)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border px-4 py-2">1</td>
                    <td className="border px-4 py-2">8753</td>
                    <td className="border px-4 py-2">3750</td>
                    <td className="border px-4 py-2">5003</td>
                    <td className="border px-4 py-2">494997</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">2</td>
                    <td className="border px-4 py-2">8753</td>
                    <td className="border px-4 py-2">3712</td>
                    <td className="border px-4 py-2">5041</td>
                    <td className="border px-4 py-2">489956</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">3</td>
                    <td className="border px-4 py-2">8753</td>
                    <td className="border px-4 py-2">3675</td>
                    <td className="border px-4 py-2">5078</td>
                    <td className="border px-4 py-2">484878</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">4</td>
                    <td className="border px-4 py-2">8753</td>
                    <td className="border px-4 py-2">3637</td>
                    <td className="border px-4 py-2">5116</td>
                    <td className="border px-4 py-2">479762</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">5</td>
                    <td className="border px-4 py-2">8753</td>
                    <td className="border px-4 py-2">3597</td>
                    <td className="border px-4 py-2">5156</td>
                    <td className="border px-4 py-2">474606</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">6</td>
                    <td className="border px-4 py-2">8753</td>
                    <td className="border px-4 py-2">3555</td>
                    <td className="border px-4 py-2">5198</td>
                    <td className="border px-4 py-2">469408</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">7</td>
                    <td className="border px-4 py-2">8753</td>
                    <td className="border px-4 py-2">3513</td>
                    <td className="border px-4 py-2">5240</td>
                    <td className="border px-4 py-2">464168</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">8</td>
                    <td className="border px-4 py-2">8753</td>
                    <td className="border px-4 py-2">3468</td>
                    <td className="border px-4 py-2">5285</td>
                    <td className="border px-4 py-2">458883</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">9</td>
                    <td className="border px-4 py-2">8753</td>
                    <td className="border px-4 py-2">3422</td>
                    <td className="border px-4 py-2">5331</td>
                    <td className="border px-4 py-2">453552</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">10</td>
                    <td className="border px-4 py-2">8753</td>
                    <td className="border px-4 py-2">3376</td>
                    <td className="border px-4 py-2">5377</td>
                    <td className="border px-4 py-2">448175</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">11</td>
                    <td className="border px-4 py-2">8753</td>
                    <td className="border px-4 py-2">3326</td>
                    <td className="border px-4 py-2">5427</td>
                    <td className="border px-4 py-2">442748</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">12</td>
                    <td className="border px-4 py-2">8753</td>
                    <td className="border px-4 py-2">3276</td>
                    <td className="border px-4 py-2">5477</td>
                    <td className="border px-4 py-2">437271</td>
                  </tr>
                </tbody>
              </table>
            </div> */}
       
<div className="mt-6">
  {/* Table view for medium and up */}
  <div className="hidden md:block overflow-x-auto">
    <table className="w-full text-lg text-gray-600 mt-4 border-collapse">
      <thead>
        <tr className="bg-gray-100">
          <th className="border px-4 py-2 text-left">Month</th>
          <th className="border px-4 py-2 text-left">EMI (₹)</th>
          <th className="border px-4 py-2 text-left">Interest (₹)</th>
          <th className="border px-4 py-2 text-left">Principal (₹)</th>
          <th className="border px-4 py-2 text-left">Outstanding Principal  (₹)</th>
        </tr>
      </thead>
      <tbody>
        {[
          
       
            ["1", "8753", "3750", "5003", "494997"],
            ["2", "8753", "3712", "5041", "489956"],
            ["3", "8753", "3675", "5078", "484878"],
            ["4", "8753", "3637", "5116", "479762"],
            ["5", "8753", "3597", "5156", "474606"],
            ["6", "8753", "3555", "5198", "469408"],
            ["7", "8753", "3513", "5240", "464168"],
            ["8", "8753", "3468", "5285", "458883"],
            ["9", "8753", "3422", "5331", "453552"],
            ["10", "8753", "3376", "5377", "448175"],
            ["11", "8753", "3326", "5427", "442748"],
            ["12", "8753", "3276", "5477", "437271"]
     
        ].map(([month, emi, interest, principal, balance], index) => (
          <tr key={index}>
            <td className="border px-4 py-2">{month}</td>
            <td className="border px-4 py-2">{emi}</td>
            <td className="border px-4 py-2">{interest}</td>
            <td className="border px-4 py-2">{principal}</td>
            <td className="border px-4 py-2">{balance}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>

  {/* Card layout for small screens */}
  <div className="md:hidden space-y-4 mt-4">
    {[
        ["1", "8753", "3750", "5003", "494997"],
        ["2", "8753", "3712", "5041", "489956"],
        ["3", "8753", "3675", "5078", "484878"],
        ["4", "8753", "3637", "5116", "479762"],
        ["5", "8753", "3597", "5156", "474606"],
        ["6", "8753", "3555", "5198", "469408"],
        ["7", "8753", "3513", "5240", "464168"],
        ["8", "8753", "3468", "5285", "458883"],
        ["9", "8753", "3422", "5331", "453552"],
        ["10", "8753", "3376", "5377", "448175"],
        ["11", "8753", "3326", "5427", "442748"],
        ["12", "8753", "3276", "5477", "437271"]
    ].map(([month, emi, interest, principal, balance], index) => (
      <div key={index} className="bg-white shadow rounded-xl p-4 text-sm text-gray-700 space-y-1 border">
        <div><span className="font-semibold">Month:</span> {month}</div>
        <div><span className="font-semibold">EMI (₹):</span> {emi}</div>
        <div><span className="font-semibold">Interest (₹):</span> {interest}</div>
        <div><span className="font-semibold">Principal (₹):</span> {principal}</div>
        <div><span className="font-semibold">Outstanding Principal  (₹):</span> {balance}</div>
      </div>
    ))}
  </div>
</div>

          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Benefits of Using TheFinMaster’s Education Loan EMI Calculator
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Here are some key benefits of using TheFinMaster’s Education Loan EMI Calculator:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Simplicity and Convenience:</strong> It saves you time and effort by calculating the EMI automatically based on your inputs.</li>
              <li><strong>Pre-Planning for Repayments:</strong> By knowing your EMIs in advance, you can plan your finances accordingly and avoid any surprises.</li>
              <li><strong>Customize Your Loan Terms:</strong> Adjust the loan amount, interest rate, and tenure to see how these variables impact your EMI.</li>
              <li><strong>Stay on Track:</strong> Helps you ensure you’re financially ready for monthly payments, reducing the chances of missing due dates or facing financial hardship.</li>
              <li><strong>Accurate Calculation:</strong> The calculator uses the same formula lenders use, ensuring that the EMI figures you receive are precise and reliable.</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Factors That Affect Your Education Loan EMI
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Several factors influence the EMI you will pay on your education loan. Understanding these factors helps you manage your loan better. The key factors include:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Loan Amount:</strong> The higher the loan amount, the higher the EMI, as more funds are being borrowed.</li>
              <li><strong>Interest Rate:</strong> The interest rate significantly affects your EMI. A higher interest rate means a higher EMI, while a lower interest rate reduces your monthly payment.</li>
              <li><strong>Loan Tenure:</strong> The loan tenure determines the number of months over which the loan will be repaid. A shorter tenure means higher EMIs but quicker repayment, while a longer tenure results in lower EMIs but extended repayment.</li>
              <li><strong>Repayment Schedule:</strong> Some lenders may offer flexible repayment schedules that affect the EMI amount, depending on when you begin repayment (immediately or after course completion).</li>
              <li><strong>Collateral:</strong> Loans secured against collateral may attract a lower interest rate, leading to a lower EMI.</li>
              <li><strong>Loan Type:</strong> Different education loans may have varied terms and conditions that impact the EMI, such as government-backed loans versus private loans.</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              By understanding these factors, you can make more informed decisions about your education loan.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Who Should Use an Education Loan EMI Calculator?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Anyone considering an education loan should use the EMI calculator. This includes:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Students:</strong> Those planning to pursue higher education abroad or in India and need financial assistance.</li>
              <li><strong>Parents:</strong> Those looking to finance their children's education and want to understand the cost of repayments.</li>
              <li><strong>Education Loan Seekers:</strong> Individuals interested in comparing various loan options to find the best repayment terms for their financial situation.</li>
              <li><strong>Financial Planners:</strong> Those helping clients plan education loans effectively can use the EMI calculator to provide realistic repayment strategies.</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Education Loan vs Personal Loan: A Quick Comparison
            </h2>
            {/* <div className="overflow-x-auto">
              <table className="w-full text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-4 border-collapse">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border px-4 py-2 text-left">Feature</th>
                    <th className="border px-4 py-2 text-left">Education Loan</th>
                    <th className="border px-4 py-2 text-left">Personal Loan</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border px-4 py-2">Purpose</td>
                    <td className="border px-4 py-2">Specifically for education</td>
                    <td className="border px-4 py-2">Multipurpose</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">Interest Rate</td>
                    <td className="border px-4 py-2">Lower, 8% to 13%</td>
                    <td className="border px-4 py-2">Higher, 10% to 24%</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">Moratorium Period</td>
                    <td className="border px-4 py-2">Yes</td>
                    <td className="border px-4 py-2">No</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">Collateral Requirement</td>
                    <td className="border px-4 py-2">May or may not be required</td>
                    <td className="border px-4 py-2">Not required (usually)</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">Tax Benefits</td>
                    <td className="border px-4 py-2">Eligible under Sec 80E</td>
                    <td className="border px-4 py-2">Not eligible</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">Tenure</td>
                    <td className="border px-4 py-2">Up to 15 years</td>
                    <td className="border px-4 py-2">Usually up to 5 years</td>
                  </tr>
                </tbody>
              </table>
            </div> */}
            <div className="hidden md:block mt-4">
            <table className="w-full text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-4 border-collapse">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border px-4 py-2 text-left">Feature</th>
                    <th className="border px-4 py-2 text-left">Education Loan</th>
                    <th className="border px-4 py-2 text-left">Personal Loan</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border px-4 py-2">Purpose</td>
                    <td className="border px-4 py-2">Specifically for education</td>
                    <td className="border px-4 py-2">Multipurpose</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">Interest Rate</td>
                    <td className="border px-4 py-2">Lower, 8% to 13%</td>
                    <td className="border px-4 py-2">Higher, 10% to 24%</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">Moratorium Period</td>
                    <td className="border px-4 py-2">Yes</td>
                    <td className="border px-4 py-2">No</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">Collateral Requirement</td>
                    <td className="border px-4 py-2">May or may not be required</td>
                    <td className="border px-4 py-2">Not required (usually)</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">Tax Benefits</td>
                    <td className="border px-4 py-2">Eligible under Sec 80E</td>
                    <td className="border px-4 py-2">Not eligible</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">Tenure</td>
                    <td className="border px-4 py-2">Up to 15 years</td>
                    <td className="border px-4 py-2">Usually up to 5 years</td>
                  </tr>
                </tbody>
              </table>
  
</div>

{/* Mobile Cards */}
<div className="md:hidden space-y-4 mt-4">
  {[
 {
    "feature": "Purpose",
    "education_loan": "Specifically for education",
    "personal_loan": "Multipurpose"
  },
  {
    "feature": "Interest Rate",
    "education_loan": "Lower, 8% to 13%",
    "personal_loan": "Higher, 10% to 24%"
  },
  {
    "feature": "Moratorium Period",
    "education_loan": "Yes",
    "personal_loan": "No"
  },
  {
    "feature": "Collateral Requirement",
    "education_loan": "May or may not be required",
    "personal_loan": "Not required (usually)"
  },
  {
    "feature": "Tax Benefits",
    "education_loan": "Eligible under Sec 80E",
    "personal_loan": "Not eligible"
  },
  {
    "feature": "Tenure",
    "education_loan": "Up to 15 years",
    "personal_loan": "Usually up to 5 years"
  }

  ].map((item, index) => (
    <div key={index} className="border rounded-lg p-4 shadow-sm bg-white">
      <p className="font-semibold text-gray-700 mb-2">{item.feature}</p>
      <div className="text-sm text-gray-600">
        <p><span className="font-medium">Business Loan:</span> {item.education_loan}</p>
        <p><span className="font-medium">Personal Loan :</span> {item.personal_loan}</p>
      </div>
    </div>
  ))}
</div>
          </div>
        </div>

     <div className="w-full md:w-1/3 p-4">
       <div className="bg-white shadow-md rounded-lg overflow-hidden">
         <div className="bg-blue-100 px-4 py-2 border-b border-blue-600 ">
           <h2 className="text-lg font-semibold ">Popular Categories</h2>
         </div>
         <div className="p-2 ">
         <ul>
                                <Link to='/financial-tools-calculators/swp-calculator'>
                                    <li className="py-2  hover:bg-slate-100 border-b border-gray-300">SWP Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/mutul-fund-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Mutual Fund Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/sukanya-samriddhi-yojana-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Samriddhi Yojana Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/fd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">FD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/rd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">RD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/nps-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NPS Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/hra-exemption-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">HRA Exemption Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/retirement-planning-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Retirement Planning Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">EMI Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/simple-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Simple Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/compound-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Compound Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/nsc-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NSC Calculator</li>

                                </Link><Link to='/financial-tools-calculators/step-up-sip-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Step Up Sip Calculator</li>

                                </Link><Link to='/financial-tools-calculators/income-tax-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Income Tax Calculator</li>
                                    
                                </Link><Link to='/financial-tools-calculators/home-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Home Loan Emi Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/car-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Car Loan Emi Calculator</li>
                                </Link>
                                {/* {categories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
                            </ul>
                        </div>
                    </div>
                          {/* Ad Banner */}
  <div className="mt-4">
    <div className="bg-white shadow-md rounded-lg overflow-hidden">
      <div className="p-3 w-full h-auto rounded-md object-cover">
        <AdBanner displayOrder="2" />
      </div>
    </div>
  </div>
                    <div className="bg-white shadow-md rounded-lg overflow-hidden mt-4">
                        <div className="bg-blue-100 px-4 py-2 border-b border-blue-600">
                            <h2 className="text-lg font-semibold">More Categories</h2>
                        </div>
                        <div className="p-2">
                        <ul>
                                <Link to='/financial-tools-calculators/gratuity-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Gratuity Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/APY-calculator'>
                                    <li className="py-2 border- hover:bg-slate-100 border-gray-300">APY Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/cagr-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">CAGR Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/gst-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">GST Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/flat-vs-reducing-rate-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Flat Vs Reducing Rate Calculator</li>
                                </Link>
                                {/* <Link to='/financial-tools-calculators/equity-margin-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Equity Margin Calculator</li>
                                </Link> */}
                                <Link to='/financial-tools-calculators/inflation-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Inflation Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/salary-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Salary Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/brokerage-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Brokerage Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/tds-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">TDS Calculator</li>
                                </Link>
             {/* {moreCategories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
           </ul>
         </div>
       </div>

     </div>

   </div>
   </div>
   <div className="max-w-4xl mx-auto lg:px-6 md:px-6 px-2 py-6">
                <h2 className="text-center text-2xl md:text-2xl lg:text-3xl font-bold mb-8">Frequently Asked Questions</h2>
                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div key={index} className="border rounded-lg overflow-hidden shadow-md">
                            <button
                                onClick={() => toggleAccordion(index)}
                                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
                            >
                                {faq.question}
                                <Icon id={index} open={activeIndex} />
                            </button>
                            {activeIndex === index && (
                                <div className="p-4 bg-gray-100">
                                    <p className="text-gray-700">{faq.answer}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
   </>
  );
};

export default EducationLoanEmiCalculator;
